import { render, staticRenderFns } from "./DocumentTagListPage.vue?vue&type=template&id=24ef41ea&"
import script from "./DocumentTagListPage.vue?vue&type=script&lang=ts&"
export * from "./DocumentTagListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports